// extracted by mini-css-extract-plugin
export default {"uniswap-link-container":"UniswapLink_uniswap-link-container__xRl3E"};